import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { Navbar } from "@/components/landing/Navbar";
import { Footer } from "@/components/landing/Footer";

export default function PlaceholderPage({ eyebrow, title, description }) {
  useEffect(() => {
    window.lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-baseLight min-h-screen">
      <Navbar />
      <main className="px-4 sm:px-6 pt-[150px] pb-[100px] lg:pt-[200px] lg:pb-[140px]">
        <div className="max-w-[640px] mx-auto text-center">
          <span className="text-sm font-medium text-teal">{eyebrow}</span>
          <h1 data-testid="placeholder-page-title" className="font-heading text-3xl sm:text-4xl font-semibold text-ink mt-3 leading-tight">
            {title}
          </h1>
          <p data-testid="placeholder-page-description" className="text-inkSoft leading-relaxed text-base mt-5">
            {description}
          </p>
          <p data-testid="placeholder-coming-soon" className="text-sm text-inkMuted mt-6">
            Full page content coming soon.
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              data-testid="placeholder-back-home"
              className="flex items-center gap-1.5 text-sm text-inkSoft hover:text-teal transition-colors duration-300"
            >
              <ArrowLeft size={15} /> Back to Home
            </Link>
            <Link
              to="/#contact"
              data-testid="placeholder-request-assessment"
              className="flex items-center gap-2 bg-ink text-white text-sm font-medium rounded-full px-6 py-3 hover:bg-teal transition-all duration-300"
            >
              Request Assessment <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
